/**
 * External Services Configuration
 * All external URLs and endpoints are configured here for easy replacement
 */

interface ServicesConfig {
  apiBaseUrl: string;
  apiTimeout: number;
}

const rawApiBaseUrl = import.meta.env.VITE_API_URL ?? 'https://api.reinfo.zahab.pe/v1';
const normalizedApiBaseUrl = rawApiBaseUrl.replace(/\/v1(\/v1)+\/?$/, '/v1');

const config: ServicesConfig = {
  apiBaseUrl: normalizedApiBaseUrl,
  apiTimeout: 30000,
};

export default config;

// Re-export individual values for convenience
export const API_BASE_URL = config.apiBaseUrl;
export const API_TIMEOUT = config.apiTimeout;
